// Procedurally generated UI sounds via WebAudio. No external assets needed.

let ctx: AudioContext | null = null;
function actx(): AudioContext {
  if (!ctx) ctx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)();
  return ctx;
}

function tone(freq: number, dur: number, type: OscillatorType = "sine", gain = 0.08) {
  try {
    const ac = actx();
    const o = ac.createOscillator();
    const g = ac.createGain();
    o.frequency.value = freq;
    o.type = type;
    g.gain.setValueAtTime(0, ac.currentTime);
    g.gain.linearRampToValueAtTime(gain, ac.currentTime + 0.005);
    g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + dur);
    o.connect(g).connect(ac.destination);
    o.start();
    o.stop(ac.currentTime + dur);
  } catch { /* empty */ }
}

export const sounds = {
  send(enabled = true) { if (enabled) { tone(880, 0.08, "triangle", 0.06); setTimeout(() => tone(1320, 0.06, "triangle", 0.05), 60); } },
  receive(enabled = true) { if (enabled) tone(660, 0.12, "sine", 0.05); },
  notify(enabled = true) { if (enabled) { tone(523, 0.1, "sine", 0.06); setTimeout(() => tone(659, 0.12, "sine", 0.06), 90); } },
  click() { tone(1500, 0.03, "square", 0.025); },
};
